import LangEnum from '../../../../lang/LangEnum';
import DropboxConfig from '../../../dropbox-config/DropboxConfig';
import DropboxHowItWorks from '../../../dropbox-config/DropboxHowItWorks';
import { useTranslation } from '../../../translation/TranslationContext';
import SettingContainer from '../../SettingContainer';
import { DropboxSectionGeneralSettingsProps } from '../types/GeneralSettings.types';

const DropboxSectionGeneralSettings = ({
  generalSettings,
  fetchGeneralSettings,
}: DropboxSectionGeneralSettingsProps) => {
  const { translate } = useTranslation();

  return (
    <SettingContainer
      title={translate(LangEnum.GENERAL_SETTINGS_DROPBOX_TITLE)}
      renderInfo={() => <DropboxHowItWorks fileSplitter={generalSettings.fileCodesSeparator} />}
    >
      <DropboxConfig
        selectedFolder={generalSettings.dropboxDefaultFolder}
        configId={generalSettings.dropboxConfigId}
        errorCode={generalSettings.dropboxErrorCode}
        fileSplitter={generalSettings.fileCodesSeparator}
        fetchGeneralSettings={fetchGeneralSettings}
      />
    </SettingContainer>
  );
};

export default DropboxSectionGeneralSettings;
